import { connect } from 'react-redux';
import { withAnalytics } from 'analytics';
import { getIsLoggedIn } from 'store/reducers/user';
import { stop, loadOnDemandClip } from 'actions/player-actions';
import {
  getOnDemandPlaybackTime,
  getIsLoading,
  getIsCurrentOnDemandPlaying,
  getOnDemandPlaybackDuration,
  isCurrentOnDemandActiveSelector,
  isPlayerInitialized,
} from 'store/reducers/player';
import { getUserSearch } from 'store/reducers/search';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import OnDemandTile from './OnDemandTile';

const mapStateToProps = (state, ownProps) => ({
  isLoading: getIsLoading(state),
  isPlaying: getIsCurrentOnDemandPlaying(state, ownProps),
  isActive: isCurrentOnDemandActiveSelector(state, ownProps),
  playerInitialized: isPlayerInitialized(state),
  onDemandClipInPlayerTime: getOnDemandPlaybackTime(state, ownProps),
  onDemandClipInPlayerDuration: getOnDemandPlaybackDuration(state),
  userSearched: getUserSearch(state),
  isLoggedIn: getIsLoggedIn(state),
  clip: ownProps,
});

const loadOnDemandClipWithAnalytics = withAnalytics(loadOnDemandClip, {
  player_name: 'tile',
  link_id: CONTENT_TYPES.ONDEMAND_TILE,
});

const stopWithAnalytics = withAnalytics(stop, {
  player_name: 'tile',
  link_id: CONTENT_TYPES.ONDEMAND_TILE,
});

const mapDispatchToProps = {
  onPlay: loadOnDemandClipWithAnalytics,
  onStop: stopWithAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(OnDemandTile);
